const CHANGE_FILTER = 'realhub/admin/digitalTemplateBuilder/templateFilters/CHANGE_FILTER'
const CHANGE_MULTIPLE_FILTERS = 'realhub/admin/digitalTemplateBuilder/templateFilters/CHANGE_MULTIPLE_FILTERS'

// Initial State
const initialState = {
  filterAgencyId: 'all',
  filterArchived: false,
  filterBrandId: 'all',
  filterLimit: '100',
  filterServiceId: 'all',
  filterString: '',
  filterType: 'all',
}

// Actions
export function changeFilter(name, value){
  return {
    type: CHANGE_FILTER,
    name,
    value,
  }
}

export function changeMultipleFilters(filters = {}){
  return {
    type: CHANGE_MULTIPLE_FILTERS,
    filters,
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  const { type } = action

  switch (type){
    case CHANGE_FILTER:
      return {
        ...state,
        [action.name]: action.value,
      }
    case CHANGE_MULTIPLE_FILTERS:
      return {
        ...state,
        ...action.filters,
      }
    default:
      return state
  }
}
